/* eslint-disable no-shadow */
import { TriggerDarkMode, CreateDarkModeKey } from "@/stores/actions/DarkMode.js";

const state = { isDarkModeOn: JSON.parse(localStorage.getItem("DarkMode")) };

const actions = {
	[TriggerDarkMode]: ({ commit }, darkMode) =>
	{
		localStorage.setItem("DarkMode", darkMode);
		commit(TriggerDarkMode);
	},
	[CreateDarkModeKey]: ({ commit }) =>
	{
		const key = localStorage.getItem("DarkMode");
		if (key === null)
		{
			localStorage.setItem("DarkMode", false);
			commit(TriggerDarkMode);
		}
	},
};
const getters = { isDark: (state) => state.isDarkModeOn };
const mutations = {
	[TriggerDarkMode]: () =>
	{
		state.isDarkModeOn = JSON.parse(localStorage.getItem("DarkMode"));
	},
};

export default {
	state,
	actions,
	mutations,
	getters,
};
